export enum LayerApproach {
  INVERSE = 'inverse',
  NULL = 'null',
}
